import { motion } from "framer-motion";

export function WhereToStay({ destination, areas }) {
  return (
    <section id="areas" className="py-24" style={{ backgroundColor: "#ffffff" }}>
      <div className="max-w-[1200px] mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 22 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          viewport={{ once: true, margin: "-80px" }}
          className="mb-12"
        >
          <p className="text-xs font-bold uppercase tracking-[0.28em] mb-2" style={{ color: "#E8470A" }}>
            Zonas y barrios
          </p>

          <h2 className="text-3xl md:text-4xl font-extrabold text-balance leading-tight" style={{ color: "#111827" }}>
            Dónde alojarse en {destination}
          </h2>

          <p className="mt-3 max-w-2xl leading-relaxed text-[15px]" style={{ color: "#6B7280" }}>
            Cada zona de {destination} tiene su propia personalidad. Elegí según el tipo
            de viaje que buscás y encontrá el alojamiento perfecto para tu estadía.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {areas.map((area, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: i * 0.09, ease: "easeOut" }}
              viewport={{ once: true, margin: "-50px" }}
              whileHover={{ y: -5, transition: { duration: 0.2 } }}
              className="group rounded-2xl overflow-hidden"
              style={{ backgroundColor: "#ffffff", border: "1px solid #f0ece4", boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={area.image}
                  alt={area.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0" style={{ background: "linear-gradient(to top, rgba(0,0,0,0.55), transparent)" }} />
                <span
                  className="absolute top-3 left-3 text-xs font-bold px-2.5 py-1 rounded-full"
                  style={{ backgroundColor: "rgba(255,255,255,0.95)", color: "#E8470A" }}
                >
                  {area.tag}
                </span>
              </div>

              <div className="p-4">
                <h3 className="font-bold text-base mb-2" style={{ color: "#111827" }}>
                  {area.name}
                </h3>
                <p className="text-sm leading-relaxed mb-4" style={{ color: "#6B7280" }}>
                  {area.description}
                </p>
                <a
                  href="#alojamientos"
                  className="inline-flex items-center gap-1 font-semibold text-sm hover:gap-2.5 transition-all duration-200"
                  style={{ color: "#E8470A" }}
                >
                  Ver alojamientos <span>→</span>
                </a>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
